import axios from "../customize_axios"

export const getAllPermissions = async (token) => {
    try {
        const response = await axios.get(
            `api/permissions`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getAllPermissions", error.response ? error.response.data : error.message)
        return []
    }
}

export const getAllAdmins = async (token, page) => {
    try {
        const response = await axios.get(
            `api/admin/all?page=${page}`,
            {
                headers: {  
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getAllAdmins", error.response ? error.response.data : error.message)
        return []
    }
}
export const addAdmin = async (token, adminData) => {
    try {
        const response = await axios.post(
            `api/admin/create`,
            adminData,
            {
                headers: {  
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response
    } 
    catch (error) {
        console.log("addAdmin", error.response ? error.response.data : error.message)
        return []
    }
}

export const updatePermission = async (token, adminData) => {
    try {
        const response = await axios.post(
            `api/admin/update-permission`,
            adminData,
            {
                headers: {  
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response
    } 
    catch (error) {
        console.log("addAdmin", error.response ? error.response.data : error.message)
        return []
    }
}

export const blockAdmin = async (token, email) => {
    try {
        const response = await axios.post(
            `api/admin/block?email=${email}`,
            {},
            {
                headers: {  
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response
    } 
    catch (error) {
        console.log("blockAdmin", error.response ? error.response.data : error.message)
        return []
    }
}

export const unblockAdmin = async (token, email) => {
    try {
        const response = await axios.post(
            `api/admin/unblock?email=${email}`,
            {},
            {
                headers: {  
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response
    } 
    catch (error) {
        console.log("unblockAdmin", error.response ? error.response.data : error.message)
        return []
    }
}

export const resetPasswordForAdmin = async (token, email) => {
    try {
        const response = await axios.post(
            `api/admin/reset-password?email=${email}`,
            {},
            {
                headers: {  
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response
    } 
    catch (error) {
        console.log("resetPasswordForAdmin", error.response ? error.response.data : error.message)
        return []
    }
}

export const getAdminsByPermission = async (token, permissionID, page) => {
    try {
        const response = await axios.get(
            `/api/admin/permission/${permissionID}?page=${page}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getAdminsByPermission", error.response ? error.response.data : error.message)    
    }
}

export const getAdminsBySearch = async (token, searchText, page) => {
    try {
        const response = await axios.get(
            `api/admin/search?keyword=${searchText}&page=${page}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getAdminsBySearch", error.response ? error.response.data : error.message)   
    }
}


export const getMyInfo = async (token) => {
    try {
      const response = await axios.get('api/my-info', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // Trả về dữ liệu từ API
    } catch (error) {
      console.log('getMyInfo', error.response ? error.response.data : error.message);
      return null; // Trả về null nếu có lỗi
    }
  };